.item {
    display: block;
    cursor: pointer;
    transition: background-color 0.15s ease, border-radius 0.15s ease,
        padding 0.15s ease;
    padding: var(--mantine-spacing-xs) 0;
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid var(--mantine-color-gray-3);

    &,
    & * {
        text-decoration: none;
    }

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: var(--dib-light-blue-hover);
        border-radius: var(--mantine-radius-sm);
        padding: var(--mantine-spacing-xs);
    }

    &:focus-visible {
        outline: none;
        background-color: var(--dib-light-blue-hover);
        border-radius: var(--mantine-radius-sm);
        padding: var(--mantine-spacing-xs);
    }

    &:hover .leadingIcon,
    &:focus-visible .leadingIcon {
        color: var(--mantine-color-gneis-9);
    }

    &:hover .chevron,
    &:focus-visible .chevron {
        opacity: 1;
        transform: translateX(0);
    }
}

.itemContent {
    width: 100%;
    overflow: hidden;
}

.itemTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.itemDescription {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.leadingIcon {
    transition: color var(--transition-duration-normal)
        var(--transition-ease-snappy);
    flex-shrink: 0;
}

.chevron {
    opacity: 0;
    transform: translateX(-8px);
    transition: opacity var(--transition-duration-fast)
            var(--transition-ease-snappy),
        transform var(--transition-duration-fast) var(--transition-ease-snappy);
    flex-shrink: 0;
    color: var(--mantine-color-gray-6);
}
